import {useEffect, useState} from 'react';
import {getFeatureValue} from '../services/featureHubClient';

export function useFeature(featureKey) {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const updateFeature = () => {
      const newValue = getFeatureValue(featureKey, false);
      setEnabled(newValue);
    };

    updateFeature();

    const interval = setInterval(updateFeature, 30000);

    return () => {
      clearInterval(interval);
    };
  }, [featureKey]);

  return enabled;
}
